<template>
  <div class="main-header">
    <div class="logo">
      <img src="static/assets/images/logo.png" alt="" width="150"/>
    </div>
    <div class="menu-toggle">
      <div></div>
      <div></div>
      <div></div>
    </div>
    <div style="margin: auto"></div>
    <div class="header-part-right">
      <!-- Full screen toggle -->
      <!-- Notificaiton -->
      <!-- Notificaiton End -->
      <!-- User avatar dropdown -->
      <div class="dropdown">
        <div class="user col align-self-end">
          <img
            :src="profileImg === 'N/A' ? 'static/assets/images/users/avatar_2x.png' :  profileImg !== undefined ? `https://demo.brihantransport.co.ke/backend/public/assets/images/${profileImg}` : ''"
            id="userDropdown"
            alt=""
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          />
          <div
            class="dropdown-menu dropdown-menu-right"
            aria-labelledby="userDropdown"
          >
            <div class="dropdown-header">
              <i class="i-Lock-User mr-1"></i> {{usernames}} 
            </div>
            <li class="dropdown-item" @click="signOut()"><router-link to=""><i class="fa fa-power-off"></i> Logout</router-link></li>
            <!-- <a class="dropdown-item" href="signin.html">Sign out</a> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";

export default {
  computed: mapGetters(["usernames", "profileImg"]),
  methods: mapActions(["signOut"]),
};
</script>


// WEBPACK FOOTER //
// src/layouts/header.vue